import { IconButton, makeStyles } from '@material-ui/core';
import { Close as IconClose } from '@material-ui/icons';
import { useSnackbar } from 'notistack';
import React from 'react';
import theme from '../../../styles/theme';

const useStyles = makeStyles(() => ({
    icon: {
        color: theme.palette.ascents.white
    }
}))


const SnackbarCloseButton = ({ onClick }) => {
    const classes = useStyles()
    const { closeSnackbar } = useSnackbar();

    return (
        <IconButton onClick={onClick}>
            <IconClose className={classes.icon} />
        </IconButton>
    );
}

export default SnackbarCloseButton;